import  {useEffect, useState} from 'react'
import {PublisherData} from './PublisherDashboard';
import ReactEcharts from 'echarts-for-react';

interface Props {
    pubDat: PublisherData[],
    style: {},
    dsp
}

const PublisherBarChart = (props: Props) => {
    const [option, setOption] = useState<any>()

    useEffect(() => {
        loadOptions()
    }, [props.dsp, props.pubDat])

    const loadOptions = () => {

        let reqData: any[] = []
        let winData: any[] = []
        let impData: any[] = []
        let viewData: any[] = []
        let clickData: any[] = []
        let vastStartData: any[] = []
        let vastCompleteData: any[] = []
        let nameData: any[] = []

        if (props.dsp) {
            props.pubDat.forEach(d => {
                if (!props.dsp || d.name === props.dsp) {
                    nameData.push({value: d.name})
                    reqData.push({value: d.request});
                    winData.push({value: d.win})
                    impData.push({value: d.impression})
                    viewData.push({value: d.view})
                    clickData.push({value: d.click})
                    vastStartData.push({value: d.vastStart})
                    vastCompleteData.push({value: d.vastComplete})
                }
            });
        } else {
            reqData[0] = 0
            winData[0] = 0
            impData[0] = 0
            viewData[0] = 0
            clickData[0] = 0
            vastStartData[0] = 0
            vastCompleteData[0] = 0
            nameData[0] = 'Total'
            props.pubDat.forEach(d => {
                if (!props.dsp || d.name === props.dsp) {
                    reqData[0] += Number.parseInt(d.request)
                    winData[0] += Number.parseInt(d.win)
                    impData[0] += Number.parseInt(d.impression)
                    viewData[0] += Number.parseInt(d.view)
                    clickData[0] += Number.parseInt(d.click)
                    vastStartData[0] += Number.parseInt(d.vastStart)
                    vastCompleteData[0] += Number.parseInt(d.vastComplete)
                }
            });
        }

        const chartOption = {
            title: {
                text: 'Events',
                subtext: 'by Dsp',
                left: 'left'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                type: 'scroll',
                top: '6%',
                left: 'center',
                data: ['Request', 'Win', 'Impression', 'View', 'Click', 'VastStart', 'VastComplete']
            },
            grid: {
                top: '12%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    axisLabel: {
                        interval: 0,
                        // rotate: 45
                    },
                    data: nameData
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    nameTextStyle: {
                        align: 'left',
                    }

                }
            ],
            series: [
                {
                    name: 'Request',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: reqData
                },
                {
                    name: 'Win',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: winData
                },
                {
                    name: 'Impression',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: impData
                },
                {
                    name: 'View',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: viewData
                },
                {
                    name: 'Click',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: clickData
                },
                {
                    name: 'VastStart',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: vastStartData
                },
                {
                    name: 'VastComplete',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: vastCompleteData
                }
            ]
        }
        setOption(chartOption)
    };

    return  <div>
                {option && <ReactEcharts style={props.style} option={option}/>}
            </div>
}

export default PublisherBarChart
